import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { Auth } from '@core/auth/auth';

const ROUTE_ALIASES: Record<string, string[]> = {};

export const permissionGuard: CanActivateChildFn = (_route, state) => {
  const router = inject(Router);
  const auth = inject(Auth);

  const currentUrl = state.url;

  if (
    currentUrl === '/dashboard' ||
    currentUrl.startsWith('/dashboard/') ||
    currentUrl.startsWith('/employee/list/profile-info') ||
    currentUrl === '/employee/profile-info' ||
    currentUrl.startsWith('/access-denied')
  ) {
    return true;
  }

  // Ensure authenticated user session exists before evaluating route permissions
  const hasAuth = auth.currentUser() || localStorage.getItem('token') || localStorage.getItem('auth_user');
  if (!hasAuth) {
    return router.createUrlTree(['/login']);
  }

  const menus: any[] =
    Array.isArray(auth.menuList) && auth.menuList.length > 0
      ? auth.menuList
      : JSON.parse(localStorage.getItem('menus') || '[]');

  // Normalize current URL to match backend menu links that end in /list or form child paths
  let normalizedUrl = currentUrl;
  if (normalizedUrl.includes('/add')) {
    normalizedUrl = normalizedUrl.replace(/\/add$/, '/list');
  } else if (normalizedUrl.includes('/new')) {
    normalizedUrl = normalizedUrl.replace(/\/new$/, '/list');
  } else if (normalizedUrl.includes('/edit/')) {
    normalizedUrl = normalizedUrl.replace(/\/edit\/.*$/, '/list');
  } else if (normalizedUrl.includes('/view/')) {
    normalizedUrl = normalizedUrl.replace(/\/view\/.*$/, '/list');
  }

  const matchedMenu = menus.find((menu) => {
    if (!menu?.link) return false;
    if (currentUrl.startsWith(menu.link) || normalizedUrl.startsWith(menu.link)) {
      return true;
    }
    for (const [route, aliases] of Object.entries(ROUTE_ALIASES)) {
      if (currentUrl.startsWith(route) || normalizedUrl.startsWith(route)) {
        if (aliases.some((alias) => menu.link.startsWith(alias) || alias.startsWith(menu.link))) {
          return true;
        }
      }
    }
    return false;
  });

  if (!matchedMenu) {
    return router.createUrlTree(['/access-denied']);
  }

  if (matchedMenu.can_view === false) {
    return router.createUrlTree(['/access-denied']);
  }

  if (matchedMenu?.id) {
    auth.selectedMenuID = matchedMenu.id;
  }

  return true;
};
